// extracted by mini-css-extract-plugin
module.exports = {"similarListingsBox":"styles_similarListingsBox__4bVKM","title":"styles_title__QUJsi"};
module.exports.__checksum = "e5e443dd6209"
